import React from 'react'
import { FormControl } from '@mui/material'
import Select, { SingleValue } from 'react-select'
import { SelectChangeEvent } from '@mui/material/Select'
import { useTranslation } from 'react-i18next'
import { useExclusiveMenu } from '../../hooks/useExclusiveMenu'
import { TypeProjet } from '../../utils/constants'
import { systemLabel } from '../../utils/systemLabel'
import { incyiaSelectStyles } from '../../utils/incyiaSelectStyles'
import '../../i18n'

interface SelectTypeProjetProps {
  value: string
  onChange: (event: SelectChangeEvent<string>, child: React.ReactNode) => void
  disablePortalMenu?: boolean
  hideLabel?: boolean
}

const SelectTypeProjet: React.FC<SelectTypeProjetProps> = ({
  value,
  onChange,
  disablePortalMenu = false,
  hideLabel = true,
}) => {
  const { t } = useTranslation()
  const menu = useExclusiveMenu(!disablePortalMenu)

  const options = TypeProjet.map((type) => ({
    value: type,
    label: systemLabel(t, 'projectType', type),
  }))

  const selectedOption = options.find((opt) => opt.value === value) || null

  const handleSelectChange = (
    selected: SingleValue<{ value: string; label: string }>
  ) => {
    onChange(
      {
        target: { name: 'type-projet', value: selected ? selected.value : '' },
      } as SelectChangeEvent<string>,
      null
    )
  }

  return (
    <div style={{ width: '100%', position: 'relative' }}>
      {!hideLabel ? (
        <label
          style={{
            position: 'absolute',
            top: '-8px',
            left: '12px',
            fontSize: '12px',
            color: 'rgba(0, 0, 0, 0.6)',
            backgroundColor: 'white',
            padding: '0 4px',
            zIndex: 60,
          }}
        >
          {t('TypeProjet')}
        </label>
      ) : null}
      <FormControl fullWidth style={{ width: '100%' }}>
        <Select
          value={selectedOption}
          onChange={handleSelectChange}
          options={options}
          placeholder={t('TypeProjet')}
          styles={incyiaSelectStyles}
          isMulti={false}
          {...menu}
        />
      </FormControl>
    </div>
  )
}

export default SelectTypeProjet
